import {getStationCode} from "../util/NetworkUtil"
import {publishClientSideMetrics} from "../handler/ParentDataHandler"
export const METRIC_PROCESS_NAME = "SCC_PROBLEMSOLVE"
export const METRIC_PROCESS_NAME_WITH_STATION_CODE = "SCC_PROBLEMSOLVE_" + getStationCode().stationCode;

export function logOperationalMetric(startTime, processName, metricName, isSuccess) {
    isSuccess ?
        publishToCSM({
            startTime: startTime,
            processName: processName,
            metricName: metricName
        }) : publishCountToCSM({
            processName: processName,
            metricName: metricName
        })
}

function publishToCSM(args) {
    let metricValue = getTimeDiff(args.startTime);
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, 1, metricTypeEnum.COUNT);
    const timeMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, metricValue, metricTypeEnum.TIME);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(timeMetricReq);
}

export function publishCountToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName , 1, metricTypeEnum.COUNT);
    const failureMetricReq = publishClientSideMetricsRequest(args.processName, `${args.metricName}-failure` , 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(failureMetricReq);
}

function getTimeDiff(time) {
    return Date.now() - time;
}

const metricTypeEnum = {
    COUNT: "count",
    TIME: "time"
};

function publishClientSideMetricsRequest(processName, metricName, metricValue, metricType) {
    return {
        processName: processName,
        metricName: metricName,
        metricValue: metricValue,
        metricType: metricType
    }
}


// WEBPACK FOOTER //
// ./src/components/util/MetricsUtil.js